export default function KeuntunganBermitra(){
    return(
      <div className='container-alur'>
          <h2 className='text-header'>Keuntungan Bermitra dengan <span>Danai.id</span></h2>
          <div className='keuntungan-bermitra'>
              <div className='section'>
                  <img src={require('../../../../assets/img/product/welfare.png')} alt='welfare'/>
                  <p>Memiliki program atau fasilitas kesejahteraan bagi karyawan</p>
              </div>
              <div className='middle-section'>
                  <img src={require('../../../../assets/img/product/startup.png')} alt='welfare'/>
                  <p>Meningkatkan kinerja karyawan</p>
              </div>
              <div className='section'>
                  <img src={require('../../../../assets/img/product/performance-review.png')} alt='welfare'/>
                  <p>Meningkatkan daya saing perusahaan dalam merekrut dan mempertahankan karyawan</p>
              </div>
          </div>
          <div className='info-section'>
              <p>Jika Perusahaan Anda masih belum bermitra dengan Danai.id, silahkan menghubungi kami di <b>customer.care@danai.id</b> atau <a>klik disini</a>.</p>
          </div>
      </div>
    );
}